import { editorPicks } from "@/mocks/comics";

const STATS = [
  { value: "1200+", label: "精选漫画" },
  { value: "48", label: "主题栏目" },
  { value: "30w+", label: "书友收藏" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* decorative panels */}
      <div className="pointer-events-none absolute -right-16 top-8 h-64 w-64 rotate-12 rounded-[2rem] bg-primary-100/70" aria-hidden="true"></div>
      <div className="pointer-events-none absolute -left-10 bottom-6 h-40 w-40 rotate-6 rounded-full bg-secondary-100/70" aria-hidden="true"></div>
      <div className="pointer-events-none absolute right-1/3 top-1/2 h-24 w-24 -rotate-12 rounded-2xl border-2 border-accent-200" aria-hidden="true"></div>

      <div className="relative mx-auto max-w-7xl px-4 pt-28 pb-16 md:px-6 md:pt-36 md:pb-24">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-8">
          <div className="text-center lg:text-left">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-medium text-accent-700">
              <i className="ri-focus-3-line" aria-hidden="true"></i>
              你的私人漫画小秘书
            </span>
            <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl md:leading-tight">
              告别大海捞针，
              <br />
              好漫我帮你<em className="not-italic text-primary-600">先读一遍</em>
            </h1>
            <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base lg:mx-0">
              编辑推荐书单、每日精选好漫、秘书严选冷门佳作，还有本月热荐与编辑私藏。
              我们替你把每一部值得读的漫画翻到最后一页，再用一句话告诉你：这部，值不值得你花时间。
            </p>
            <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center lg:justify-start">
              <a
                href="#编辑推荐"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
              >
                看看编辑推荐
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
              <a
                href="#常见问题"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 sm:w-auto"
              >
                了解小秘
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
              {STATS.map((stat) => (
                <div key={stat.label} className="text-center lg:text-left">
                  <dt className="sr-only">{stat.label}</dt>
                  <dd className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                    {stat.value}
                  </dd>
                  <dd className="mt-1 text-xs text-foreground-500">{stat.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          {/* cover collage */}
          <div className="relative mx-auto hidden max-w-md lg:block">
            <div className="relative">
              <div className="absolute -inset-4 -rotate-3 rounded-[1.5rem] bg-gradient-to-br from-primary-200 via-secondary-100 to-accent-100" aria-hidden="true"></div>
              <div className="relative flex gap-4">
                <div className="w-1/2 overflow-hidden rounded-xl border-2 border-background-50">
                  <img
                    src={editorPicks[0].cover}
                    alt={`${editorPicks[0].title} 漫画封面`}
                    className="aspect-[3/4] w-full object-cover object-top"
                  />
                </div>
                <div className="flex w-1/2 flex-col gap-4 pt-8">
                  <div className="overflow-hidden rounded-xl border-2 border-background-50">
                    <img
                      src={editorPicks[1].cover}
                      alt={`${editorPicks[1].title} 漫画封面`}
                      className="aspect-square w-full object-cover object-top"
                    />
                  </div>
                  <div className="flex items-center gap-3 rounded-xl bg-foreground-900 p-4 text-background-50">
                    <i className="ri-award-line text-2xl text-secondary-300" aria-hidden="true"></i>
                    <p className="text-xs leading-relaxed">
                      今日严选 · 《{editorPicks[2].title}》
                      <br />
                      <span className="text-background-300">{editorPicks[2].note}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}